module.exports = __webpack_public_path__ + "static/media/icon-score-3-scale-5.9373059b.png";